module.exports = __webpack_public_path__ + "media/images/athletes/998-8ad3a2615e468800ec4f364d316928c3.png";